module.exports = __webpack_public_path__ + "393eab5da6b0cc5fa9e7e61548090813.fbx";